import { ReturnAppSettings } from "@redotech/redo-customer-portal-shared/settings";
import { Offering } from "@redotech/redo-model/extended-warranty";
import { Button, ButtonTheme } from "@redotech/redo-web/button";
import { CurrencyContext } from "@redotech/redo-web/currency";
import { Elements } from "@stripe/react-stripe-js";
import type { Stripe, StripeElements } from "@stripe/stripe-js";
import { memo, useContext, useState } from "react";
import * as review from "../review.module.css";
import { Payment } from "./payment";

export const EWPaymentCard = memo(function EWPaymentCard({
  settings,
  stripe,
  submit,
  submitPending,
  elements,
  setElements,
  selectedOffering,
}: {
  settings: ReturnAppSettings;
  stripe: Stripe;
  submit: () => void;
  submitPending: boolean;
  elements: StripeElements | undefined;
  setElements: (elements: StripeElements | undefined) => void;
  selectedOffering: Offering | undefined;
}) {
  const { formatCurrency } = useContext(CurrencyContext);
  const [paymentInfoFilled, setPaymentInfoFilled] = useState<boolean>(false);

  const disabled = !stripe || !elements || !paymentInfoFilled;

  if (!selectedOffering) {
    return null;
  }

  return (
    <div className={review.summaryCard}>
      <div className={review.summaryHeader}>Summary</div>
      <div className={review.summaryCardItem}>
        <div className={review.summaryText}>
          {selectedOffering.title} protection plan
        </div>
        <div className={review.summaryText}>
          {formatCurrency(selectedOffering.price.amount)}
        </div>
      </div>
      <div>
        <Elements stripe={stripe}>
          <Payment
            nextStep={submit}
            setElements={setElements}
            setPaymentInfoFilled={setPaymentInfoFilled}
            settings={settings}
          />
        </Elements>
      </div>
      <hr className={review.line} />
      <div className={review.summaryCardItemPayment}>
        <div className={review.summaryTextBold}>Total</div>
        <div className={review.summaryText}>
          {formatCurrency(selectedOffering.price.amount)}
        </div>
      </div>
      <div className={review.button}>
        <Button
          disabled={disabled}
          onClick={submit}
          pending={submitPending}
          style={{ width: "100%" }}
          theme={ButtonTheme.PRIMARY}
          type="submit"
        >
          Submit registration
        </Button>
      </div>
    </div>
  );
});
